<template>
    <el-table-column label="Action" align="right">
        <template slot="header">
            <!-- <lq-table-form> -->
                <lq-el-input id="search" placeholder="Search" :inside-form-item="false" size="mini" />
            <!-- </lq-table-form> -->
        </template>
        <template slot-scope="scope" >
            <!-- {{viewRoute}} -->
            <el-button
                v-if="$root.can(restorePermission) && (forTrashed || scope.row.deleted_at)  "
                @click="restoreRecord(scope.row)"
                icon="el-icon-refresh" 
                type="success"
                title="Restore"
                :circle="true"
            />
            <el-button
            v-else-if="$root.can(editPermission) && viewRoute != 'users/:id/show'"
            icon="el-icon-edit" 
            type="primary"
            :circle="true"
            @click="$router.push(viewRoute.replace(':id', $helper.getProp(scope, 'row.id', null)))"/>
            <router-link :to="{name: 'user_view',params: { id: $helper.getProp(scope, 'row.id', null) }}" target="_blank" v-if="$root.can(editPermission) && viewRoute == 'users/:id/show'" class="el-button el-button--primary el-button--medium is-circle"><i class="el-icon-edit"></i></router-link>
            <el-button
            v-if="$root.can(deletePermission) && (!noForId || noForId !== scope.row.id)"
            @click="deleteRecord(scope.row)"
            icon="el-icon-delete" 
            :title="scope.row.deleted_at ? 'Delete Permanently': 'Delete'"
            type="danger"
            :circle="true"/>
        </template>
    </el-table-column>
</template>
<script>

export default {
    name : 'lq-el-table-action',
    props: {
        deleteRequest : {
            type:  Function,
        },
        confirmMessage:{
            type : String
        },
        forTrashed : {
            type :Boolean,  
            default : function (){return false}
        },
        noForId: Number,
        viewRoute:{
            type: String
        },
        restoreRequest :{
            type : Function
        },
        restoreMessage : {
            type : String
        },
        viewPermission : {
            type : String
        },
        editPermission  : {
            type : String
        },
        deletePermission : {
            type : String
        },
        restorePermission : {
            type : String
        }
    },
    methods : {
        
        deleteRecord: function(data) {            
            this.$confirm(this.confirmMessage, 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteRequest(data)
            }).catch(() => {
             this.$message({
                type: 'info',
                message: 'Delete canceled'
                });       
            });
        },
        restoreRecord: function(data) {            
            this.$confirm(this.restoreMessage, 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.restoreRequest(data)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Restore canceled'
                });       
            });
        },
    }
}
</script>
